const formatStrInput = (input) => {
    let str = input.toUpperCase()
    if (str[str.length - 1] === '')
        str = str.slice(0, str.length - 1)
    return str
}
const formatNumInput = (input) => {
    let num = Number(input)
    if (isNaN(num)) {
        console.log(input)
        throw new Error('Not a Number')
    }
    return num
}
const formatNumericString = (str) => {
    let num = Number(str)
    if (isNaN(num))
        throw new Error('Not a Number')
    return num.toFixed(2)
}

export {
    formatStrInput,
    formatNumInput,
    formatNumericString
}